module.exports = __webpack_public_path__ + "static/necessary-people-86dc51eaaee12cd2e4a211ae6f827910.jpg";